var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.loading
        ? [
            _vm._l(_vm.objects.objects, function(property, index) {
              return [
                index !== 0
                  ? _c("v-divider", { staticClass: "mx-4" })
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "d-flex align-center" }, [
                  _c(
                    "div",
                    {
                      staticClass: "mr-2 d-flex justify-center align-center",
                      staticStyle: { width: "100px", height: "100px" }
                    },
                    [
                      _c(
                        "v-icon",
                        {
                          attrs: {
                            color: _vm.$vuetify.theme.dark
                              ? "white"
                              : "primary",
                            size: "70"
                          }
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(property.icon) +
                              "\n                    "
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", [
                    _c(
                      "div",
                      { staticClass: "d-flex align-center" },
                      [
                        _c(
                          "p",
                          { staticClass: "mr-1 mb-0", class: _vm.textClass },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.getPropertyValue(property)) +
                                "\n                        "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _vm.getPropertyDescription(property)
                          ? _c(
                              "v-tooltip",
                              {
                                attrs: { bottom: "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function(ref) {
                                        var on = ref.on
                                        var attrs = ref.attrs
                                        return [
                                          _c(
                                            "v-icon",
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  attrs: {
                                                    color: "grey lighten-1",
                                                    small: ""
                                                  }
                                                },
                                                "v-icon",
                                                attrs,
                                                false
                                              ),
                                              on
                                            ),
                                            [
                                              _vm._v(
                                                "\n                                    $mdiInformation\n                                "
                                              )
                                            ]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              },
                              [
                                _vm._v(" "),
                                _c("span", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.getPropertyDescription(property)
                                    )
                                  }
                                })
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("p", { class: _vm.propertyLabelClass }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(property.label) +
                          "\n                    "
                      )
                    ])
                  ])
                ])
              ]
            }),
            _vm._v(" "),
            _c("v-divider"),
            _vm._v(" "),
            _vm._l(_vm.objects.properties, function(property, index) {
              return void 0
            })
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }